import React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbRadioButton as ClbRadioButton_ } from '@celebration/design-system/dist/lib/radio-button';
const events = {
    onClbBlur: ClbRadioButton_.events
        .onClbBlur,
    onClbFocus: ClbRadioButton_.events
        .onClbFocus,
    onClbChange: ClbRadioButton_.events
        .onClbChange,
};
export const ClbRadioButton = createComponent({
    tagName: ClbRadioButton_.tagName,
    elementClass: ClbRadioButton_,
    react: React,
    events: events,
});
//# sourceMappingURL=index.js.map